import React, { useMemo, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import FontFaceObserver from 'fontfaceobserver';
import PrechatForm from '../PrechatForm/PrechatForm';
import MainContainer from '../MainContainer/MainContainer';
import ChatLauncher from '../../components/ChatLauncher/ChatLauncher';
import { setMuiFontLoaded, setWidgetIsOpen } from '../../store/actions/general';
import type { RootState } from '../../types/redux';

function Container({ prechatEnabled, prechatFormOpened }: { prechatEnabled: boolean; prechatFormOpened: boolean }) {
  if (prechatEnabled && prechatFormOpened) {
    return (
      <PrechatForm />
    )
  }

  return (
    <MainContainer />
  )
}

function RootContainer() {
  const { prechatEnabled, prechatFormOpened, widgetIsOpen } = useSelector((state: RootState) => state.general);
  const dispatch = useDispatch();

  useEffect(() => {
    const font = new FontFaceObserver('Material Icons');

    dispatch(setMuiFontLoaded(false))
    font.load(null, 10000)
      .then(() => {
        dispatch(setMuiFontLoaded(true))
      })
      .catch((error) => {
        dispatch(setMuiFontLoaded(false))
      });


    if (window.location.href.toLowerCase().includes("plasma-donation")) {
       dispatch(setWidgetIsOpen(false));
    }
  }, [dispatch]);

  return useMemo(() => {
    return (
      <div>
        {widgetIsOpen ? (
          <Container prechatEnabled={prechatEnabled} prechatFormOpened={prechatFormOpened} />
        ) : null}
        <ChatLauncher />
      </div>
    );
  }, [widgetIsOpen, prechatEnabled, prechatFormOpened])
}

export default RootContainer;
